import hubIcon from 'src/assets/icons/linesResearch/hub-icon.svg'
import balanceIcon from 'src/assets/icons/linesResearch/balance-icon.svg'
import psychologyIcon from 'src/assets/icons/linesResearch/psychology-icon.svg'
import troubleshootIcon from 'src/assets/icons/linesResearch/troubleshoot-icon.svg'
import queryStatsIcon from 'src/assets/icons/linesResearch/query-stats-icon.svg'
import shieldIcon from 'src/assets/icons/linesResearch/shield-icon.svg'

export const LINES_RESEARCH_LIST = [
  { src: hubIcon, text: 'lines-research.social-network-analysis' },
  { src: balanceIcon, text: 'lines-research.algorithmic-discrimination' },
  { src: psychologyIcon, text: 'lines-research.large-data-models' },
  { src: troubleshootIcon, text: 'lines-research.fault-identification-models' },
  { src: queryStatsIcon, text: 'lines-research.fault-prediction-models' },
  { src: shieldIcon, text: 'lines-research.data-privacy' }
]
